import { render, staticRenderFns } from "./PaymentdetailAdmin.vue?vue&type=template&id=48fe6499"
import script from "./PaymentdetailAdmin.vue?vue&type=script&lang=js"
export * from "./PaymentdetailAdmin.vue?vue&type=script&lang=js"
import style0 from "./PaymentdetailAdmin.vue?vue&type=style&index=0&id=48fe6499&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports